export default "__VITE_ASSET__2S63L2kh__"